import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as domain from '@common/domain/entities/Role';
import * as roleDTO from '@common/domain/models/RoleDTO';
import { IApiServiceCommand } from '@services/api/api.service';

export class RoleEndPoints extends domain.RoleEndPoints implements IEntityEndPoints {
  get?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/role/" + serviceCommand.context.entityId
    }
  };
  update?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/role/update/" + serviceCommand.context.entityId
    },
    method: "POST"
  };
  search?: IDataEndPoint = null;
}
export class OrganisationRoleEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/organisation/roles",
    //url: app.config.controllerRouteRoot + `/role/getOrganisations/${context.parent.parent.selectedItem.id}`,
    
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        organisationId: serviceCommand.context.entityId
      }
    }
  };
  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/delete",
    //url: app.config.controllerRouteRoot + "/role/delete?roleId={data.id}&organisationId={context.parent.parent.selectedItem.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        roleId: serviceCommand.data.id,
        organisationId: serviceCommand.context.pentityId
      }
    },
    method: "POST"
  };
  search?: IDataEndPoint = null;
}
export class UserRoleEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/user/roles",
    //url: app.config.controllerRouteRoot + "/user/getRoles/{context.parent.parent.selectedItem.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId
      }
    }
  };
  insert?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/user/addRole",
    //url: app.config.controllerRouteRoot + "/user/addRole?userId={context.parent.parent.selectedItem.id}&roleId={serviceCommand.data.id}&organisationId={serviceCommand.data.organisationId}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        roleId: serviceCommand.data.id,
        userId: serviceCommand.context.entityId,
        organisationId: serviceCommand.data.organisationId
      }
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/user/removeRole",
    //url: app.config.controllerRouteRoot + "/user/removeRole?userId={context.parent.parent.selectedItem.id}&roleId={serviceCommand.data.id}&organisationId={serviceCommand.data.organisationId}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        roleId: serviceCommand.data.id,
        userId: serviceCommand.context.entityId,
        organisationId: serviceCommand.data.organisationId
      }
    },
    method: "POST"
  };
  search?: IDataEndPoint = null;
}


export class OrganisationRoleListColumns extends Array<IColumnOptions> {
  public name: IColumnOptions = { field: "name" };
  public description: IColumnOptions = { field: "description" };
  constructor() {
    super();
    this.push(this.name);
    this.push(this.description);
  }
}

export class OrganisationRoleListSetup implements IGridOptions {
  protected organisationRoleListName: string = "organisationRoleList";
  protected organisationRoleListModel: roleDTO.RoleDTO = new roleDTO.RoleDTO();
  protected organisationRoleListEndPoints: RoleEndPoints = new RoleEndPoints();
  protected organisationRoleListColumns: OrganisationRoleListColumns = new OrganisationRoleListColumns();
  public roleForm: RoleForm = new RoleForm();
  public get name(): string { return this.organisationRoleListName };
  public get model(): roleDTO.RoleDTO { return this.organisationRoleListModel };
  public get endPoints(): IEntityEndPoints { return this.organisationRoleListEndPoints };
  public set endPoints(roleEndPoints: IEntityEndPoints) {
    this.organisationRoleListEndPoints = roleEndPoints;
    this.roleForm.endPoints = this.endPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
  public get columns(): OrganisationRoleListColumns { return this.organisationRoleListColumns };
}

export class RoleListColumns extends Array<IColumnOptions> {
  public name: IColumnOptions = { field: "name" };
  constructor() {
    super();
    this.push(this.name);
  }
}

export class UserRoleListColumnsSetup extends Array<IColumnOptions> {
  public selected: IColumnOptions = { field: "selected", width: "140px" };
  public organisation: IColumnOptions = { field: "organisation" };
  public name: IColumnOptions = { field: "name" };
  public description: IColumnOptions = { field: "description" };
  constructor() {
    super();
    this.push(this.selected);
    this.push(this.organisation);
    this.push(this.name);
    this.push(this.description);
  }
}

export class UserRoleListSetup implements IGridOptions {
  protected userRoleListName: string = "userRoleList";
  protected userRoleListModel: roleDTO.RoleDTO = new roleDTO.RoleDTO();
  protected userRoleListEndPoints: RoleEndPoints = new RoleEndPoints();
  protected userRoleListColumns: UserRoleListColumns = new UserRoleListColumns();
  public roleForm: RoleForm = new RoleForm();
  public get name(): string { return this.userRoleListName };
  public get model(): roleDTO.RoleDTO { return this.userRoleListModel };
  public get endPoints(): IEntityEndPoints { return this.userRoleListEndPoints };
  public set endPoints(roleEndPoints: IEntityEndPoints) {
    this.userRoleListEndPoints = roleEndPoints;
    this.roleForm.endPoints = this.endPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
  public get columns(): UserRoleListColumns { return this.userRoleListColumns };
}

export class RoleFormFields extends domain.RoleFormFields {
  constructor() {
    super();
    this.splice(0, this.length);
    this.push(this.name);
    this.push(this.description);
  }
}

export class RoleForm extends domain.RoleForm implements IFormOptions {
  public get displayName(): string { return "name" };
  protected roleFormEndPoints: RoleEndPoints = new RoleEndPoints(); protected roleFormFields: RoleFormFields = new RoleFormFields();
}

export class OrganisationRoleList extends OrganisationRoleListSetup implements IGridOptions {
  protected organisationRoleListEndPoints: OrganisationRoleEndPoints = new OrganisationRoleEndPoints();
}

export class UserRoleListColumns extends UserRoleListColumnsSetup {
  constructor() {
    super();
    this.selected.readOnly = false;
    this.selected.endPoints = new UserRoleEndPoints();
  }
}
export class UserRoleList extends UserRoleListSetup implements IGridOptions {
  protected userRoleListEndPoints: UserRoleEndPoints = new UserRoleEndPoints();
  protected userRoleListColumns: UserRoleListColumns = new UserRoleListColumns();
  public disableNavigation: boolean = true;

}

export class GlobalRoleEndPoints extends domain.RoleEndPoints {
  list?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/role/getByOrganisation/00000000-0000-0000-0000-000000000000", method: "GET" };
}
export class GlobalRoleList extends domain.RoleList {
  protected roleListEndPoints: GlobalRoleEndPoints = new GlobalRoleEndPoints();
  protected roleListModel: roleDTO.RoleDTO = new roleDTO.RoleDTO();
}

